// extracted by mini-css-extract-plugin
export var avatarContainer = "_1d-0";
export var avatarTypingWave = "_1d-i";
export var gray = "_1d-f";
export var green = "_1d-c";
export var icon = "_1d-9";
export var image = "_1d-1";
export var lg = "_1d-6";
export var md = "_1d-5";
export var presenceDot = "_1d-b";
export var red = "_1d-d";
export var sm = "_1d-4";
export var status = "_1d-a";
export var typingDot = "_1d-h";
export var typingPill = "_1d-g";
export var xl = "_1d-7";
export var xs = "_1d-3";
export var xxl = "_1d-8";
export var xxs = "_1d-2";
export var yellow = "_1d-e";